export function getRyanAirReferences(airOrder) {
    if (!airOrder.airlineReferencesByLeg) {
        return [];
    }
    const references = airOrder.airlineReferencesByLeg
        .filter((reference) => reference.legIdentifier.some(({ segmentIndex, legIndex }) => {
        const leg = airOrder.flightSegments?.[segmentIndex]?.legs?.[legIndex];
        return (leg.flightInfo.carrierInfo?.marketingCarrier === "RK" || leg.flightInfo.carrierInfo?.marketingCarrier === "FR");
    }))
        .map((reference) => reference.reference);
    return [...new Set(references)];
}
export const isRyanairLegs = (legs) => {
    return !!legs?.every((leg) => {
        return (leg.flightInfo.carrierInfo?.marketingCarrier === "RK" || leg.flightInfo.carrierInfo?.marketingCarrier === "FR");
    });
};
export const isRyanairSegments = (segments) => {
    return !!segments?.every((segment) => isRyanairLegs(segment.legs));
};
export const isRyanairFlight = (order) => {
    return isRyanairSegments(order.airOrder.flightSegments);
};
export const isAnyRyanairSegments = (segments) => {
    return !!segments?.some((segment) => {
        return segment.legs.some((leg) => {
            return (leg.flightInfo.carrierInfo?.marketingCarrier === "RK" || leg.flightInfo.carrierInfo?.marketingCarrier === "FR");
        });
    });
};
export const isAnyLegIsRyanAir = (order) => {
    return isAnyRyanairSegments(order.airOrder.flightSegments);
};
